/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class QueryGridConfigurationModel {
        public currentQueryGrid: Wars.Domain.Model.Gis.QueryGridConfiguration;
        public mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        public currentEsriQuery:Wars.Domain.Model.Gis.EsriQueryConfiguration;
        public gisDatastoreQuery:Wars.Domain.Model.Gis.GisDatastoreQueryConfiguration;
        public systemLevel:Wars.Domain.Model.SystemLevel;

        constructor(private mapConfigurationService: services.MapConfigurationService,
            private deleteService:services.DeleteService,
            private systemLevelService:services.SystemLevelService,
            private mapConfigurationId: string) {
            this.mapConfigurationService.getMapConfiguration(mapConfigurationId).then(m => {
                this.mapConfiguration = m;
            });

            this.systemLevelService.getSystemLevelJsonDictionaryStores().then(systemLevel => {
                this.systemLevel = systemLevel;
            });
        }

        public addQueryGrid() {
            let queryGrid = this.mapConfigurationService.createQueryGridConfiguration();

            queryGrid.includeZoomColumn = true;
            queryGrid.zoomToResultsOnQuery = false;
            queryGrid.highlightOnHover = false;
            queryGrid.runQueryOnLoad = false;
            queryGrid.includeLoadButton = true;
            queryGrid.addResultsToMap =false;
            queryGrid.name = "New Query Grid";

            this.mapConfiguration.queryGridConfigurations.push(queryGrid);

            this.save();
        }

        public addEsriQuery() {
            let newQuery = this.addQuery();
            newQuery.esriQueryConfiguration = this.currentEsriQuery;

            this.save();
        }

        public addGisDatastoreQuery() {
            let newQuery = this.addQuery();
            newQuery.gisDatastoreQueryConfiguration= this.gisDatastoreQuery;

            this.save();
        }

        public addQuery():Wars.Domain.Model.Gis.QueryGridQuery {
            let newQuery = this.mapConfigurationService.createQueryGridQuery();

            this.currentQueryGrid.queryGridQueries.push(newQuery);
            return newQuery;
        }

        public addField() {
            let field = this.mapConfigurationService.createIncludedQueryField();
            field.uniqueId = services.UtilityService.generateGuidComb();
            field.showInPopup = false;
            field.displayOrder = this.currentQueryGrid.includedQueryFields.length + 1;
            field.name = "New Field";
            field.distictOnField = false;

            this.currentQueryGrid.includedQueryFields.push(field);

            this.save();
        }

        public addResultsToMapChanged() {
            if (this.currentQueryGrid.addResultsToMap && !this.currentQueryGrid.drawStyle) {
                this.currentQueryGrid.drawStyle = this.mapConfigurationService.createDrawStyle();
            }

            this.save();
        }



        public fieldOrderDown(field: Wars.Domain.Model.Gis.IncludedQueryField) {
            const newPosition = field.displayOrder + 1;

            var oldField= Enumerable.from(this.currentQueryGrid.includedQueryFields).singleOrDefault(c => c.displayOrder == newPosition);

            if (oldField) {
                oldField.displayOrder--;
                field.displayOrder++;
            }

            this.save();
        }

        public fieldOrderUp(field: Wars.Domain.Model.Gis.IncludedQueryField) {
            const newPosition = field.displayOrder - 1;

            var oldField = Enumerable.from(this.currentQueryGrid.includedQueryFields).singleOrDefault(c => c.displayOrder == newPosition);

            if (oldField) {
                oldField.displayOrder++;
                field.displayOrder--;
            }

            this.save();
        }

        public removeField(field: Wars.Domain.Model.Gis.IncludedQueryField) {
            field.entityAspect.setDeleted();
            this.save();
        }

        public removeQueryField(field: Wars.Domain.Model.Gis.GisFieldMapping) {
            field.entityAspect.setDeleted();
            this.save();
        }

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }
    }
}